<!-- @format -->

@if (title) {
  <h3 class="list-title">{{ title }}</h3>
}
@if (enrolments.length > 0) {
  @for (enrolment of getEnrolmentList(); track enrolment) {
    <div class="enrolment-course-unit">
      <app-enrolment-box
        data-cy="enrolments-view-enrolment-box"
        (enrolmentClickAction)="handleEnrolmentButtonClick(enrolment, $event.action)"
        (enrolmentCancelAction)="cancelEnrolment(enrolment, $event.action)"
        (enrolmentRemoveAction)="removeEnrolment(enrolment)"
        [enrolment]="enrolment">
      </app-enrolment-box>
    </div>
  }
  @if (fullListVisible || enrolments.length > getEnrolmentList().length) {
    <sis-show-more
      class="show-more"
      [text]="
        fullListVisible
          ? ('ENROLMENTS.SHOW_LESS_REALISATIONS' | translate)
          : ('ENROLMENTS.SHOW_MORE_REALISATIONS' | translate: { count: enrolments.length - getEnrolmentList().length })
      "
      [direction]="fullListVisible ? 'ccw-90' : 'cw-90'"
      [placement]="fullListVisible ? 'top' : 'bottom'"
      (showMoreChanged)="showMoreEnrolments()"
      data-cy="show-more-enrolments">
    </sis-show-more>
  }
} @else {
  <p class="guidance">{{ emptyListText }}</p>
}
